var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentIconComponentName,{key:_vm.key,tag:"component",staticClass:"base-icon",attrs:{"icon":_vm.icon,"color":_vm.color,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }